<div class="buy-olx-packages crm-scroll">
  <div class="buy-olx-packages-wrapper">
    <ng-container *ngTemplateOutlet="titleTemplate" />
    <ng-container *ngTemplateOutlet="contentTemplate" />
    <ng-container *ngTemplateOutlet="loaderTemplate" />
  </div>
</div>

<ng-template #contentTemplate>
  <div class="buy-olx-packages-content">
    @if (!loaders.categories && categories && categories.length && selectedCategoryId.value) {
      <ng-container *ngTemplateOutlet="nothingFoundTemplate" />
      <ng-container *ngTemplateOutlet="packagesTemplate" />
      <ng-container *ngTemplateOutlet="zonesTemplate" />
    }
    <ng-container *ngTemplateOutlet="categoriesTemplate" />
  </div>
</ng-template>

<ng-template #nothingFoundTemplate>
  @if (!this.loaders.zones && !this.loaders.packages && !this.zones.length && !this.totalPackagesCount) {
    <mat-card class="buy-olx-packages-card nothing-found">
      <span class="buy-olx-packages-card-title">{{ 'nothing_found' | translate }}</span>
    </mat-card>
  }
</ng-template>

<ng-template #packagesTemplate>
  @if (totalPackagesCount || loaders.packages) {
    <mat-card class="buy-olx-packages-card package-card">
      @if (totalPackagesCount) {
        <span class="buy-olx-packages-card-title">
          {{ 'buy_olx_packages.package_label' | translate }}
        </span>

        <div class="buy-olx-packages-card-card-container">
          @for (p of packageCardsToShow; track $index) {
            @let selectedPackage = controlByType(p.type).value;

            <mat-card
              class="buy-olx-packages-card-card"
              [ngClass]="{ selected: isUpdateSelected(p.type, selectedPackage) }"
            >
              <div class="buy-olx-packages-card-card-header">
                <span class="buy-olx-packages-card-card-title">
                  @switch (p.type) {
                    @case (AvailablePackageType.BASE) {
                      {{ 'olx.packages.start' | translate }}
                    }
                    @case (AvailablePackageType.PREMIUM) {
                      {{ 'olx.packages.premium' | translate }}
                    }
                    @case (AvailablePackageType.MEGA) {
                      {{ 'olx.packages.mega' | translate }}
                    }
                  }
                </span>
                <app-select
                  class="buy-olx-packages-card-card-input"
                  [formControl]="controlByType(p.type)"
                  labelType="float"
                  [options]="packages[p.type]"
                  optionLabel="size"
                  label="buy_olx_packages.adverts_amount"
                  labelVariant="on"
                  [matTooltip]="$safeNavigationMigration(selectedPackage?.name)"
                />
              </div>

              <div class="buy-olx-packages-card-card-price-container">
                <div class="buy-olx-packages-card-card-price">
                  {{ selectedPackage?.price ?? 0 | number: '1.2-2' }} {{ 'UAH' | translate }}.
                </div>
                <div class="buy-olx-packages-card-card-subprice">
                  <strong>
                    {{ (selectedPackage ? selectedPackage.price / selectedPackage.size : 0) | number: '1.2-2' }}
                    {{ 'UAH' | translate }}.
                  </strong>
                  {{ 'buy_olx_packages.for_one_advert' | translate }}
                </div>
              </div>

              <div class="buy-olx-packages-card-card-actions-container">
                <div class="buy-olx-packages-card-card-actions">
                  <app-button
                    class="buy-olx-packages-card-card-buy"
                    (onChangeClick)="plannerId ? onUpdatePlanner(p.type) : onBuyType(p.type)"
                    [full]="true"
                    [disabled]="!canBuyByType(p.type)"
                  >
                    @if (plannerId) {
                      @if (isUpdateSelected(p.type, selectedPackage)) {
                        {{ 'buy_olx_packages.update' | translate }}
                      } @else {
                        {{ 'buy_olx_packages.select' | translate }}
                      }
                    } @else {
                      {{ 'buy_olx_packages.pay' | translate }}
                    }
                  </app-button>

                  @if (!plannerId) {
                    <app-button
                      (onChangeClick)="onOpenPlanner(p.type)"
                      btnType="icon"
                      [matTooltip]="'plan_now' | translate"
                      [disabled]="!canBuyByType(p.type)"
                    >
                      <app-icon>calendar_month</app-icon>
                    </app-button>
                  }
                </div>
                <div class="buy-olx-packages-card-card-actions-description">
                  {{ 'buy_olx_packages.actions_description' | translate }}
                </div>
              </div>

              <div class="buy-olx-packages-card-card-description-container">
                <div class="buy-olx-packages-card-card-description-title">
                  {{ 'buy_olx_packages.contains' | translate }}:
                </div>
                <div class="buy-olx-packages-card-card-description">
                  @for (key of featuresByType(p.type); track $index) {
                    <div class="buy-olx-packages-card-card-description-item">
                      <app-icon>check</app-icon>
                      <span>{{ key | translate }}</span>
                    </div>
                  }
                </div>
              </div>
            </mat-card>
          }
        </div>
      } @else {
        <ngx-skeleton-loader class="skeleton-overlay" [theme]="{ width: '100%', height: '100%' }" />
      }
    </mat-card>
  }
</ng-template>

<ng-template #zonesTemplate>
  @if (zones.length || loaders.zones) {
    <mat-card class="buy-olx-packages-card zone-card">
      @if (zones.length) {
        <span class="buy-olx-packages-card-title">
          {{ 'buy_olx_packages.zone_label' | translate }}
        </span>

        <span class="buy-olx-packages-card-subtitle">
          {{ 'buy_olx_packages.zone_sublabel' | translate }}
        </span>

        <app-select
          class="buy-olx-packages-card-input"
          [formControl]="selectedZoneId"
          (valueChange)="onSelectZone()"
          labelType="float"
          [type]="SelectType.Cascade"
          [options]="zones"
          [focusOnHover]="false"
          optionValue="id"
          label="location"
          labelVariant="on"
          [optionGroupChildren]="['sub_zones']"
        />
      } @else {
        <ngx-skeleton-loader class="skeleton-overlay" [theme]="{ width: '100%', height: '100%' }" />
      }
    </mat-card>
  }
</ng-template>

<ng-template #categoriesTemplate>
  <mat-card class="buy-olx-packages-card">
    <span class="buy-olx-packages-card-title">{{ 'buy_olx_packages.category_label' | translate }}</span>
    <app-advert-category-picker
      [categories]="categories"
      [categoryControl]="selectedCategoryId"
      (categoryChanged)="onSelectCategory()"
      [loader]="loaders.categories"
    />
  </mat-card>
</ng-template>

<ng-template #titleTemplate>
  <div class="buy-olx-packages-title-container">
    <span class="buy-olx-packages-title">
      @if (loaders.packages || totalPackagesCount) {
        {{ 'buy_olx_packages.select_package' | translate }}
      } @else if (loaders.zones || zones.length) {
        {{ 'buy_olx_packages.select_zone' | translate }}
      } @else {
        {{ 'buy_olx_packages.select_category' | translate }}
      }
    </span>
    @if (baseService.isMobile) {
      <app-button (onChangeClick)="onCloseSidebar()" btnType="icon">
        <app-icon>close</app-icon>
      </app-button>
    }
  </div>
</ng-template>

<ng-template #loaderTemplate>
  @if (loaders.buy_packages) {
    <ngx-skeleton-loader class="skeleton-overlay" animation="pulse" [theme]="{ width: '100%', height: '100%' }" />
  }
</ng-template>
